export const ROLES = [
    { id: 'admin', title: 'Администратор' },
    { id: 'sales', title: 'Продажи' },
    { id: 'purchase', title: 'Закупки' }
];
export function roleTitle(id) {
    return ROLES.find((r) => r.id === id)?.title ?? id;
}
export function isRoleId(value) {
    return ROLES.some((r) => r.id === value);
}
export const PERMISSIONS = {
    POST_REQUEST: ['admin', 'sales'],
    SPLIT_REQUEST: ['admin', 'sales'],
    RENAME_ARTICLE: ['admin', 'sales'],
    POST_PURCHASE: ['admin', 'purchase'],
    POST_PACKING: ['admin', 'purchase'],
    PHOTOS: ['admin', 'purchase'],
    REBUILD: ['admin'],
    UNDO: ['admin'],
    USERS: ['admin']
};
export function can(role, permission) {
    return PERMISSIONS[permission].includes(role);
}
//# sourceMappingURL=roles.js.map